/**
 * cancelAlternativesViewModel — `(reduxState, motif) → props de <CancelAlternativesPage>`.
 *
 * Patron C (cache seul) : l'étape 2 n'appelle aucun service. Elle lit le seul champ que le legacy
 * lui donnait (`CancelAlternativesScreen.js:349-351`, `mapStateToProps`) — l'utilisateur courant,
 * dont Calendly pré-remplit les champs famille.
 */
import { createSelector } from "reselect"

import { cancelAlternativeFor } from "../../../adapters/parent/SubscriptionCancel/subscriptionCancelAdapter"
import { type UICancelAlternative } from "../../../ui/types"
import { selectDisplayedStudent } from "../../shared/displayedStudent"

export type CancelAlternativesViewModel = {
    alternative: UICancelAlternative
    /** Blob brut passé à `openCalendly` — ce n'est pas une UIType. */
    calendlySubject: unknown
}

/** Redux root is still untyped in this app — keep the VM boundary explicit. */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReduxState = any

export const cancelAlternativesViewModel = createSelector(
    [
        (state: ReduxState) => selectDisplayedStudent(state),
        (_state: ReduxState, motif: string | null | undefined) => motif,
    ],
    (calendlySubject, motif): CancelAlternativesViewModel => ({
        alternative: cancelAlternativeFor(motif),
        calendlySubject,
    })
)
